/* eslint-disable max-lines, max-statements, header/header */
// TODO #458  Refaktorování do více menších tříd.
// - Správa ScheduleManager a operace spojené se změnou obsahu.
// - Fronta požadavků na přechody.
// - Operace s přehrávaným slajdem.
// - Operace s načítaným slajdem.

/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

// TODO #458 Refaktorování do více menších tříd.
// - Správa ScheduleManager a operace spojené se změnou obsahu.
// - Fronta požadavků na přechody.
// - Operace s přehrávaným slajdem.
// - Operace s načítaným slajdem.
/* eslint-disable max-statements */

import EventEmitter from 'eventemitter3';
import isNil from 'lodash/isNil';

// TODO #458 Kdy má být šablona označena jako preloadovaná?
// - Po načtení vrstev? Po načtení pozadí?
// - Ihned. Na nic nečekat.
// TODO #458 Proces vytvoření vláken:
// - Nyní:
//   - ContentInfo (respektive jeho Task) se převede na Array.<ScheduleStrategy>
//   - Pro každou ScheduleStrategy se vytvoří ViewerThread.
// - Nově:
//   - Začíná se plánovat vždy právě jedno root vlákno s obsahem ContentInfo (respektive jeho Task).
//   - ScheduleInfo mohou nyní plánovat s koncovým prvkem Layout, vedle aktuálního Medium.
//     Jakmile se v nějakém vláknu přejde na Layout, je to signál k tomu,
//     že se mají v témto vlákně vytvořit sub-vlákna.
//     To ale bude implementační detail v ScheduleInfo, který se předá pomocí
//     getSubstrategies, které by se asi měli zkoušet vytvářet na každém slajdu.
//     Podstrategie jsou vytvářeny rodičovskou strategií.
// TODO #458 Souvislosti se změnou obsahu:
// - Nyní se řeší v Device, takže při přesunu do ViewerManager by se také měl změnit.
// - Zároveň se tento problém řeší ve ViewerDirector, který se mezi změnami nemění.
//   Na nižší úrovni je vytvořen pouze proud ScheduleInfo v čase,
//   změny v obsahu by zde neměli jít poznat.
//   To by ale vyžadovalo mít možnost měnit ScheduleStrategy v jednom ViewerThread, což asi není vhodné.
// - Jak ale příjemce pozná, které vlákno se změnilo?
//   Nyní to vlastně také nezjistí a ani nepotřebuje.
//   Vykreslování realizuje ViewerThread.
//   Události z více vláken se používají pouze pro věci jako screenshot.
// TODO #458 Jak se bude chovat rodičovské vlákno během přehrávání podvláken.
// - Vlákno vytvoří podvlákna dle ScheduleInfo#getSubstrategies.
//   Zároveň bude vždy nastavený Layout jako koncový prvek (ale teoreticky nemusí).
//   Přítomnost šablony znamená, že se pro ni samotnou žádný slajd nevytváří
//   (kromě teoreticky třeba pozadí), ale zachovává se odpočet jeho časovače ve ScheduleStrategy.
// - Jakmile zobrazení šablony vyprší, tak se podvlánka smažou.
//   Zastavení strategií podvláken bude řešit buď rodičovská strategie, nebo rušené vlákno.
//   Ale vzhledem k tomu, že se strategie vytváří v rodičovské, tak by se asi měla rušit i tam.
// TODO #458 Napojení plánování z podvláken:
// - Ty by totiž také měli ovlivňovat výsledek: např. hlasitotst, nebo pozici na obrazovce.
// - V aktuálním návrhu se s tím asi nepočítá.
//   Problém je v tom, že tyto informace jsou uvnitř rodičovské strategie,
//   přitom zde ale existuje neomezené množství strategií z podvláken.
//   Jak je napojit na rodičovskou, když jsou všechny stavové?
// - Pro zachování současné logiky bude asi cesta nejmenšího odporu v tom,
//   že strategie podvláken bude vytvářena rodičovskou strategií.
//   Asi zavést nějakou událost typu "forked", kde budou strategie z vrstev?
//   Anebo přidat tyto informace do ScheduleInfo?
//   To by asi dávalo větší smysl, když k rozdělení dochází vždy při přechodu na nový playlist.
// - Jak by to pak fungovalo při plánování?
//   Přidávat tuto informaci do ScheduleInfo#getSubstrategies.
// - Pozor na možný zmatek, kdy v ScheduleInfo je seznam layers, ve které je zanořené,
//   ale substrategie se budou vytvářet z "jedné úrovně" layers, tedy všechny vrstvy pro danou šablonu.
//   (Po zavedení parentScheduleInfo, již takový zmatek nebude.)
//   Při vytváření substrategií jim bude do konstruktoru předáno rodičovské ScheduleInfo, které pak budou výsledné mergovat.
//   (Respektive na něj odkazovat jako na parentScheduleInfo.)
//   Jak tento přístup spojit s plánováním, tam se taky mají vytvářet podstrategie a teoreticky mít i možnost spouštění?
//   Z logiky věci by se někdy mohlo hodit plánovat v podstrategiích, třeba pro zjištění jestli se bude zobrazovat video apod.
//   Na druhou stranu logika ovládání přechodů a logika plánování by měla být oddělena, což je ale možná spíše technický dluh z dřívějška.
//   Ovládat podstrategie by měla vždy jen ScheduleLayer, která je vytváří a ruší. (nebo kdo?)
// - A nebude vlastně stačit vzít naplánované ScheduleInfo z Layout vlákna
//   a slučovat ho se ScheduleInfo z Layer vláken?
//   To by asi fungovalo pro události, ale nikoliv pro vykreslování unvitř podvlákna,
//   které je přímo vázané na danou (pod)strategii.
//   Leda že by bylo podvlánko napojeno na hlavní vlákno a nějak si zjišťovalo jeho aktuální ScheduleInfo,
//   což nevypadá jako příliš vhodná konstrukce.
//   Vracení správných výsledků ze strategie se zdá logičtější.
//   Také pak bude odlišná implementace podvláken od hlavního vlákna.
// TODO Unit testy.
// TODO Skrývání elementů.
// - Je vhodné začínat s elementy ve skrytém stavu, aby se předešlo problikávání apod.
// - Při uvolnění by měl být element opět skrytý.
// - Nyní se spoléhá na to, že se vždy před uvolněním zavolá leave. Vylepšit?
// - Nyní všechny ovladače sdílejí CSS třídu "viewer-frame". Oddělit?
// - Dořešit v rámci přímého přístupu mezi `ViewerList` a `ViewerController` (bez elementů).
/**
 * Jedno vlákno zobrazující obsah v prolínači.
 * Zobrazuje posloupnost slajdů s médii.
 * ![Diagram aktivit](./core/viewer/thread/viewer-thread.doc.png)
 * @implements {Destroyable}
 * @implements {EventBus}
 */
class ViewerThread {
  /**
   * Vytvoří instanci.
   * @param {ViewerDelayerFactory} delayerFactory Továrna na správce zpoždění.
   * @param {HTMLElement} el Rodičovský eLement, do kterého se vlákno vykresluje.
   * @param {Logger} logger
   * @param {NetworkListener} networkListener Správce připojení k síti.
   * @param {ScheduleStrategy} scheduleStrategy Strategie přehrávání obsahu, který řídí, co vlákno zobrazuje.
   * @param {ViewerSlideFactory} slideFactory Továrna na slajdy pro přehrávače obsahu.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.loadLimit=Infinity] Maximální počet médií, které se přeskočí při pokusu o přednačtení následujícího slajdu.
   * @returns {ViewerThread} Nová instance.
   */
  constructor(
    delayerFactory,
    el,
    logger,
    networkListener,
    scheduleStrategy,
    slideFactory,
    { loadLimit = Infinity } = {}
  ) {
    /**
     * Správce zpoždění.
     * @private
     * @type {ViewerDelayer}
     */
    this.delayer = delayerFactory.create();
    /**
     * Rodičovský eLement, do kterého se vlákno vykresluje.
     * @private
     * @type {HTMLElement}
     */
    this.el = el;
    /**
     * Správce událostí.
     * @private
     * @type {EventEmitter}
     */
    this.emitter = new EventEmitter();
    this.loadLimit = loadLimit;
    /**
     * Příznak, jestli byl vyžádáno načtení dalšího slajdu.
     * @private
     * @type {boolean}
     */
    this.loadRequested = false;
    /**
     * Načítaný slajd, který se připravuje na pozadí.
     * @private
     * @type {ViewerSlide}
     */
    this.loadingSlide = null;
    this.logger = logger;
    /**
     * Správce připojení k síti.
     * @private
     * @type {NetworkListener}
     */
    this.networkListener = networkListener;
    /**
     * Příznak, jestli byl vyžádáno přehrání dalšího slajdu.
     * @private
     * @type {boolean}
     */
    this.playRequested = false;
    /**
     * Přehrávaný slajd, který se zobrazuje na popředí.
     * @private
     * @type {ViewerSlide}
     */
    this.playingSlide = null;
    /**
     * Fronta po sobě prováděných asynchroních operací.
     * Používá se pro zamezení paralelních přechodů mezi slajdy.
     * Všechny požadavky na načtení a přehrání musí být prováděny sériově.
     * Pokud je definována, tak to znamená, že právě probíhají nějaké operace,
     * které se ukončí v okamžiku vyřešení promise.
     * Pokud je nastavena na `null`, tak to znamená, že žádná operace neprobíhá.
     * @private
     * @type {?Promise}
     */
    this.queuePromise = null;
    /**
     * Strategie přehrávání obsahu, který řídí, co vlákno zobrazuje.
     * @private
     * @type {ScheduleStrategy}
     */
    this.scheduleStrategy = scheduleStrategy;
    this.slideFactory = slideFactory;
    /**
     * Příznak, jestli byl vyžádáno zrušení organizátoru.
     * @private
     * @type {boolean}
     */
    this.stopRequested = false;
    /**
     * Timeout pro zpoždění při změně slajdů.
     * @private
     * @type {?number}
     */
    this.timeout = null;
    // Navázání naslouchání na instanci.
    this.onOnlineChanged = this.onOnlineChanged.bind(this);
    this.onSchedulePlayed = this.onSchedulePlayed.bind(this);
    this.onSlideError = this.onSlideError.bind(this);
    this.onSlidePlayed = this.onSlidePlayed.bind(this);
  }

  /**
   * Přesune načítaný slajd do přehrávaného.
   * @private
   * @returns {undefined} Nic.
   */
  activateLoading() {
    this.playingSlide = this.loadingSlide;
    this.loadingSlide = null;
  }

  /**
   * Naváže naslouchání událostem ze slajdu.
   * @param {ViewerSlide} slide Slajd, kterému se naslouchá.
   * @private
   * @returns {undefined} Nic.
   */
  bindSlide(slide) {
    slide.on('error', this.onSlideError);
    slide.on('played', this.onSlidePlayed);
  }

  /**
   * Vytvoří nový načítaný slajd.
   * @param {ScheduleInfo} scheduleInfo Naplánované médium, které se má zobrazit ve slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po vytvoření.
   */
  createLoading(scheduleInfo) {
    // TODO #458 Zde bude nutné napojit šablony.
    // - Neprovádět nic.
    return new Promise((resolve) => {
      const slide = this.createSlide(scheduleInfo);
      this.loadingSlide = slide;
      return resolve(slide.seize());
    });
  }

  /**
   * Vytvoří nový přehrávaný slajd.
   * @param {ScheduleInfo} scheduleInfo Naplánované médium, které se má zobrazit ve slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po vytvoření.
   */
  createPlaying(scheduleInfo) {
    // TODO #458 Zde bude nutné napojit šablony.
    // - Vytvořit nové `Schedule`.
    return new Promise((resolve) => {
      const slide = this.createSlide(scheduleInfo);
      this.playingSlide = slide;
      return resolve(slide.seize());
    });
  }

  /**
   * Vytvoří nový slajd a naváže naslouchání jeho událostem.
   * @param {ScheduleInfo} scheduleInfo Naplánované médium, které se má zobrazit ve slajdu.
   * @private
   * @returns {ViewerSlide} Vytvořený slajd.
   */
  createSlide(scheduleInfo) {
    const slide = this.slideFactory.create(this.el, scheduleInfo);
    this.bindSlide(slide);
    return slide;
  }

  /**
   * Odebere zdroje načítaného slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po odebrání.
   */
  deleteLoading() {
    return this.deleteSlide(this.loadingSlide).then(() => {
      this.loadingSlide = null;
    });
  }

  /**
   * Odebere zdroje přehrávaného slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po odebrání.
   */
  deletePlaying() {
    return this.deleteSlide(this.playingSlide).then(() => {
      this.playingSlide = null;
    });
  }

  /**
   * Odebere zdroje slajdu a zruší ho.
   * @param {ViewerSlide} slide Slajd k odebrání.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po odebrání.
   */
  deleteSlide(slide) {
    return new Promise((resolve) =>
      resolve(slide.delete().then(() => this.destroySlide(slide)))
    );
  }

  /**
   * Zruší slajd a naslouchání jeho událostem.
   * @param {ViewerSlide} slide Slajd ke zrušení.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po odebrání.
   */
  destroySlide(slide) {
    this.unbindSlide(slide);
    slide.destroy();
  }

  /**
   * Postupně odebere požadavky na přechody z fronty a provede je.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po provedení všech přechodů ve frontě.
   */
  dequeue() {
    return new Promise((resolve) => {
      if (this.stopRequested) {
        this.playRequested = false;
        this.loadRequested = false;
        return resolve(this.unsetLoading().then(() => this.unsetPlaying()));
      }
      if (this.playRequested) {
        this.playRequested = false;
        this.loadRequested = false;
        return resolve(
          this.playUnsafe().then((success) => {
            const { delayer } = this;
            if (!success) {
              this.playRequested = true;
              return delayer.fail().then(() => this.dequeue());
            }
            return delayer
              .succeed()
              .then(() => this.wait())
              .then(() => this.loadUnsafe())
              .then(() => this.dequeue());
          })
        );
      }
      if (this.loadRequested) {
        this.loadRequested = false;
        return resolve(
          this.wait()
            .then(() => this.loadUnsafe())
            .then(() => this.dequeue())
        );
      }
      return resolve();
    });
  }

  /** @inheritdoc */
  destroy() {
    // TODO #458 Technické dluhy spojené s rušením vlákna prolínače.
    // - Není oficiálně podporovaný a otestovaný destroy v jiném stavu, než po volání #stop.
    // - Není dodrženo minimálně ve ViewerDirector#destroy
    // Zrušení timeoutu.
    clearTimeout(this.timeout);
    // Zrušení slajdů.
    const { loadingSlide, playingSlide } = this;
    if (!isNil(loadingSlide)) {
      this.destroySlide(loadingSlide);
    }
    if (!isNil(playingSlide)) {
      this.destroySlide(playingSlide);
    }
    // Zrušení napojení na správce sítě.
    this.networkListener.off('onlineChanged', this.onOnlineChanged);
    // Zrušení strategie.
    // TODO #458 Kdo je zodpovědný za zrušení ScheduleStrategy?
    // - Neměl by to být ten, kdo ji vytvořil? Přesunout dle finálního řešení.
    this.scheduleStrategy.off('played', this.onSchedulePlayed);
    this.scheduleStrategy.destroy();
    // Zrušení zpožďovače.
    this.delayer.destroy();
  }

  /**
   * Zobrazí přehrávaný slajd.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po zobrazení.
   */
  enterPlaying() {
    return new Promise((resolve) => {
      const { playingSlide } = this;
      return resolve(
        playingSlide.enter().then(() => {
          this.emitter.emit('entered', playingSlide.getScheduleInfo());
        })
      );
    });
  }

  /**
   * Zařadí požadavek na přechod do fronty.
   * @private
   * @returns {Promise.<undefined>}
   * Pokud není jiný požadavek ve frontě, vyřeší se po provedení požadavku a všech ostatních, které se za něj zařadí.
   * Pokud je jiný požadavek ve frontě, vyřeší se po jeho zařazení do fronty.
   */
  enqueue() {
    return new Promise((resolve) => {
      const currentPromise = this.queuePromise;
      if (!isNil(currentPromise)) {
        // TODO Hotfix čekání na zastavení vlákna při jeho rušení.
        // - Problém: Při rušení vlákna je potřeba počkat na dokončení probíhajících operací.
        //   Jde o jedinou operaci, u které je požadováno znát okamžik jeho dokončení.
        //   Ostatní operace jsou iniciovány bez zájmu znát okamžik jejich dokončení.
        //   Dříve se požadavek na `#enqueue` ihned ukončil, pokud nebyla fronta prázdná.
        //   To pak způsobilo signalizaci dokončení zastavení, když přitom bylo pouze ve frontě.
        // - Reprodukce: Nastavit krátkou dobu přehrávání médií a dlouho prodlevu při `#wait`.
        //   Nasledně obsah zrušit a zůstane zaseknutý.
        // - Hotfix: Všechny operace ve frontě se nyní ukládají do `queuePromise`.
        //   Ta se vrací v okamžiku, kdy dojde k zařazení operace do fronty.
        //   Řešení by mělo nyní postačovat, když jediná operace, kterou dokončení zajímá,
        //   způsobuje vyprázdnění celé fronty.
        // - Finální řešení: Zpracovat frontu sofistiovaněji,
        //   aby docházelo k vyřešení pořadavku v okamžiku jeho dokončení, nebo vyřazení z fronty.
        //   Nyní se vyřeší až v okamžiku dokončení všech operací ve frontě.
        return resolve(currentPromise);
      }
      const nextPromise = this.dequeue().finally(() => {
        this.queuePromise = null;
      });
      this.queuePromise = nextPromise;
      return resolve(nextPromise);
    });
  }

  /**
   * Ošetří vzniklou chybu.
   * @param {Error} error Chybový objekt.
   * @private
   * @returns {undefined} Nic.
   */
  handleError(error) {
    this.emitter.emit('error', error);
  }

  /**
   * Načte další médium.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po nastavení načtítaného média.
   */
  load() {
    return (
      new Promise((resolve) => {
        this.loadRequested = true;
        return resolve(this.enqueue());
      })
        // TODO Nemělo by být toto ošetřeno spíše v on* metodách?
        .catch((error) => this.handleError(error))
    );
  }

  /**
   * Vyhledá médium vhodné k načtení.
   * @param {number} offset Počet slajdů od aktuálně přehrávaného média.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po nastavení načtítaného média.
   */
  loadStep(offset) {
    return new Promise((resolve) => {
      if (offset > this.loadLimit) {
        // Byl překročen limit preloadovaných slajdů.
        // Vyhledávání se ukončí a načítaný slajd se ponechá, třeba se bude hodit.
        return resolve();
      }
      const scheduleInfo = this.scheduleStrategy.plan(offset)[offset - 1];
      if (!scheduleInfo.isPreloadable()) {
        // Médium není určeno k preloadu.
        // Vyhledávání se ukončí a načítaný slajd se ponechá, třeba se bude hodit.
        // Až se na médium provede přechod, tak se zobrazí rovnou bez preloadu.
        return resolve();
      }
      if (scheduleInfo.isEmpty()) {
        // Obsah je prázdný.
        // Vyhledávání se ukončí a načítaný slajd se zruší.
        return resolve(this.unsetLoading());
      }
      const { loadingSlide } = this;
      if (
        !isNil(loadingSlide) &&
        scheduleInfo.isEqual(loadingSlide.getScheduleInfo())
      ) {
        // V načítaném slajdu je již požadované médium připraveno.
        // Vyhledávání se ukončí a načítaný slajd se ponechá, když je již správně připraven.
        return resolve();
      }
      // Je nutné nastavit nový načítaný slajd.
      return resolve(
        this.unsetLoading().then(() => {
          const online = this.networkListener.isOnline();
          if (!scheduleInfo.isViewable(online)) {
            return this.loadStep(offset + 1);
          }
          return this.setLoading(scheduleInfo).then((success) => {
            if (!success) {
              return this.loadStep(offset + 1);
            }
          });
        })
      );
    });
  }

  /**
   * Načte další médium bez ošetření paralelního spuštění.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po nastavení načtítaného média.
   */
  loadUnsafe() {
    return this.loadStep(1);
  }

  /** @inheritdoc */
  off(...args) {
    this.emitter.off(...args);
  }

  /** @inheritdoc */
  on(...args) {
    this.emitter.on(...args);
  }

  /**
   * Reakce na změnu připojení k síti.
   * @param {boolean} online Příznak, jestli je zařízení připojeno k síti.
   * @private
   * @returns {undefined} Nic.
   */
  onOnlineChanged(online) {
    const { playingSlide } = this;
    if (
      !isNil(playingSlide) &&
      !playingSlide.getScheduleInfo().isViewable(online)
    ) {
      return this.play();
    }
    const { loadingSlide } = this;
    if (
      !isNil(loadingSlide) &&
      !loadingSlide.getScheduleInfo().isViewable(online)
    ) {
      return this.load();
    }
  }

  /**
   * Reakce na přehrání časovače média v plánovači.
   * @param {ScheduleInfo} scheduleInfo Naplánované informace, které byly přehrány.
   * @private
   * @returns {undefined} Nic.
   */
  onSchedulePlayed(scheduleInfo) {
    const { playingSlide } = this;
    if (isNil(playingSlide)) {
      throw new Error('Missing playing slide.');
    }
    const playingScheduleInfo = playingSlide.getScheduleInfo();
    if (!playingScheduleInfo.isEqual(scheduleInfo)) {
      throw new Error('Unexpected played slide.');
    }
    playingSlide.setPlayed(true);
    this.play();
  }

  /**
   * Reakce na chybu ve slajdu.
   * @param {ViewerSlide} slide Slajd, který vyvolal chybu.
   * @param {Error} error Chybový objekt.
   * @private
   * @returns {undefined} Nic.
   */
  onSlideError(slide, error) {
    // Ignorování chyb z ViewerSlide.
    this.logger.warn(error);
    slide.setFailed(true);
    if (slide === this.playingSlide) {
      this.play();
    }
  }

  /**
   * Reakce na fyzické přehrání média ve slajdu.
   * @param {ViewerSlide} slide Slajd, který byl přehrán.
   * @private
   * @returns {undefined} Nic.
   */
  onSlidePlayed(slide) {
    if (slide.isPlayed()) {
      return;
    }
    // #497 Médium se fyzicky přehrálo, okamžitě zastavit případně nastavené timery, aby se později
    // neemitoval další played event, který by způsobil přeskočení následujícího média.
    // Ve funkci onSlideError naopak nesmíme volat, k pádu dojde typicky v preloadu, kdy ještě timer
    // není spuštěný a zavolání this.scheduleStrategy.stop() prakticky zastaví přehrávání.
    this.scheduleStrategy.stop();
    slide.setPlayed(true);
    this.play();
  }

  /**
   * Přehraje další médium.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po nastavení přehrávaného média.
   */
  play() {
    return (
      new Promise((resolve) => {
        this.playRequested = true;
        return resolve(this.enqueue());
      })
        // TODO Nemělo by být toto ošetřeno spíše v on* metodách?
        .catch((error) => this.handleError(error))
    );
  }

  /**
   * Vyhledá médium vhodné k přehrání.
   * @private
   * @returns {Promise.<boolean>} Příznak, jestli bylo nastaveno přehrávané médium.
   */
  playStep() {
    return new Promise((resolve) => {
      const scheduleInfo = this.scheduleStrategy.go();
      if (scheduleInfo.isEmpty()) {
        return resolve(true);
      }
      const online = this.networkListener.isOnline();
      if (!scheduleInfo.isViewable(online)) {
        return resolve(false);
      }
      return resolve(this.setPlaying(scheduleInfo));
    });
  }

  /**
   * Přehraje další médium bez ošetření paralelního spuštění.
   * @private
   * @returns {Promise.<boolean>} Příznak, jestli bylo médium přehráno.
   */
  playUnsafe() {
    return this.unsetPlaying().then(() => this.playStep());
  }

  /**
   * Uvolní zdroje načítaného slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po uvolnění.
   */
  releaseLoading() {
    return this.releaseSlide(this.loadingSlide).then(() => {
      this.loadingSlide = null;
    });
  }

  /**
   * Uvolní zdroje přehrávaného slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po uvolnění.
   */
  releasePlaying() {
    return this.releaseSlide(this.playingSlide).then(() => {
      this.playingSlide = null;
    });
  }

  /**
   * Uvolní zdroje slajdu a uvolní naslouchání jeho událostem.
   * @param {ViewerSlide} slide Slajd k uvolnění.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po uvolnění.
   */
  releaseSlide(slide) {
    return new Promise((resolve) =>
      resolve(slide.release().then(() => this.unbindSlide(slide)))
    );
  }

  /**
   * Přidá načítaný slajd.
   * @param {ScheduleInfo} scheduleInfo Naplánované médium, které se má zobrazit ve slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po přidání.
   */
  setLoading(scheduleInfo) {
    return this.createLoading(scheduleInfo)
      .then(() => true)
      .catch((error) => {
        // Ignorování chyb z ViewerSlide.
        // Zde je přítomno kvůli odfiltrování chyb vznilých při získávání
        // zdrojů (např. vyčerpání PDF).
        this.logger.warn(error);
        if (!isNil(this.loadingSlide)) {
          return this.deleteLoading().then(() => false);
        }
        return false;
      });
  }

  /**
   * Přidá přehrávaný slajd.
   * @param {ScheduleInfo} scheduleInfo Naplánované médium, které se má zobrazit ve slajdu.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po přidání.
   */
  setPlaying(scheduleInfo) {
    return new Promise((resolve) => {
      const { loadingSlide } = this;
      if (
        !isNil(loadingSlide) &&
        scheduleInfo.isEqual(loadingSlide.getScheduleInfo())
      ) {
        if (loadingSlide.isFailed()) {
          return resolve(false);
        }
        this.activateLoading();
        return resolve(this.enterPlaying().then(() => true));
      }
      return resolve(
        this.createPlaying(scheduleInfo).then(() => {
          if (this.playingSlide.isFailed()) {
            return resolve(false);
          }
          return this.enterPlaying().then(() => true);
        })
      );
    }).catch((error) => {
      // Ignorování chyb z ViewerSlide.
      // Zde je přítomno kvůli odfiltrování HTMLMediaError, které vznikly
      // během enter (respektive play) u video ovladačů.
      this.logger.warn(error);
      if (!isNil(this.playingSlide)) {
        return this.deletePlaying().then(() => false);
      }
      return false;
    });
  }

  /**
   * Spustí zobrazování obsahu ve vláknu.
   * @returns {undefined} Nic.
   */
  start() {
    // Naslouchání událostem.
    this.networkListener.on('onlineChanged', this.onOnlineChanged);
    this.scheduleStrategy.on('played', this.onSchedulePlayed);
    // Spustí přehrávání prvního média.
    this.play();
  }

  /**
   * Zastaví zobrazování obsahu ve vláknu.
   * @returns {Promise.<undefined>} Vyřeší se po zastavení a uvolnění všech zdrojů.
   */
  stop() {
    // TODO Refaktrorizovat proces zrušení a zpracování front akcí, protože teď už je trochu nepřehledné.
    // - Nejprve, se zruší naslouchání statickým zdrojům, které způsobují enqueue akcí (networkListener, scheduleStrategy).
    // - Následně se postupně zruší všechny slajdy, které také způsobují enqueue (unsetLoading, unsetPlaying).
    //   Toho se dosáhne pomocí další akce, která se řadí do fronty a aktivuje se během dequeue.
    //   Priorita této akce je nejvyšší a způsobí vyprázdnění fronty, uvolnění zdrojů přehrávání.
    // - Na závěr dequeue se již nevolá enqueue, takže události, které vyvolali slajdy při rušení se ignorují.
    //   Nové enqueue již pak nemají jak vznikat a činnost vlákna je ukončena
    // - Nakonec se zruší dočasné zdroje, které se používali (scheduleStrategy, delayer).
    this.networkListener.off('onlineChanged', this.onOnlineChanged);
    this.scheduleStrategy.off('played', this.onSchedulePlayed);
    this.stopRequested = true;
    return this.enqueue();
  }

  /**
   * Uvolní naslouchání událostem ze slajdu.
   * @param {ViewerSlide} slide Slajd, kterému se naslouchá.
   * @private
   * @returns {undefined} Nic.
   */
  unbindSlide(slide) {
    slide.off('error', this.onSlideError);
    slide.off('played', this.onSlidePlayed);
  }

  /**
   * Odebere načítaný slajd.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po odebrání.
   */
  unsetLoading() {
    return new Promise((resolve) => {
      const { loadingSlide } = this;
      if (isNil(loadingSlide)) {
        return resolve();
      }
      if (loadingSlide.isFailed()) {
        return resolve(this.deleteLoading());
      }
      return resolve(
        this.releaseLoading().catch((error) => {
          this.handleError(error);
          return this.deleteLoading();
        })
      );
    });
  }

  /**
   * Odebere přehrávaný slajd.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po odebrání.
   */
  unsetPlaying() {
    return new Promise((resolve) => {
      const { playingSlide } = this;
      if (isNil(playingSlide)) {
        return resolve();
      }
      if (playingSlide.isFailed()) {
        return resolve(this.deletePlaying());
      }
      this.emitter.emit('played', playingSlide.getScheduleInfo());
      return resolve(
        playingSlide
          .leave()
          .then(() => this.releasePlaying())
          .catch((error) => {
            this.handleError(error);
            return this.deletePlaying();
          })
      );
    });
  }

  /**
   * Aplikuje zpoždění vyžadované platformou Tizen.
   * @private
   * @returns {Promise.<undefined>} Vyřeší se po zpoždění.
   */
  wait() {
    // TODO Platformově specifické prolínače. Aplikovat zpoždění pouze pro platformu Tizen.
    return new Promise((resolve) => {
      // Délka zpoždění byla zjištěna experimentálně na TV.
      this.timeout = setTimeout(resolve, 200);
    });
  }
}

/**
 * Zobrazení média.
 * @event ViewerThread#entered
 * @param {ScheduleInfo} scheduleInfo Informace o naplánovaném médiu, které byly zobrazeny.
 */

/**
 * Chybová událost.
 * @event ViewerThread#error
 * @param {Error} error Chybové hlášení.
 */

/**
 * Dosažení konce přehrávání média.
 * @event ViewerThread#played
 * @param {ScheduleInfo} scheduleInfo Informace o naplánovaném médiu, které byly přehrány.
 */

export default ViewerThread;
